import React from 'react';
import { SideBarMenu } from './SideBarMenu';
import { SideMenuProps } from './SideBarMenuProps';

export const SideMenu = ({ groups, children }: SideMenuProps) => {
	return (
		<section className="flex flex-col sm:flex-row h-full sm:h-[calc(100vh-40px)] 3xl:h-[calc(100vh-60px)] sm:pl-5 sm:pt-5 3xl:pt-7.5">
			<SideBarMenu groups={groups} />
			{children}
		</section>
	);
};
